import { useRef } from 'react';

import { Button } from '../../../cdl/Button/Button';
import { useDrawer } from '../../../cdl/Drawer/useDrawer.hook';
import { translate } from '../../../common/helpers/translate.helper';
import { IconSparkle } from '../../../common/icons/cdl/Sparkle';
import { SuggestionData, SuggestionDrawer } from '../../create-enquiry/components/SuggestionDrawer';
import { usePortSuggestionsStream } from '../../create-enquiry/hooks/usePortSuggestionsStream';

interface SuggestionButtonProps {
    orderId: string;
    onSaveDraft: (data?: SuggestionData) => Promise<void>;
    onSendEnquiry: (data: SuggestionData) => void;
    onSuggestionFinished: () => void;
    hasUnsavedChanges: boolean;
    hasSuggestionRelevantChanges: boolean;
}

export const SuggestionButton = ({
    orderId,
    onSaveDraft,
    onSendEnquiry,
    onSuggestionFinished,
    hasUnsavedChanges,
    hasSuggestionRelevantChanges,
}: SuggestionButtonProps) => {
    const { push } = useDrawer();
    const { refetch } = usePortSuggestionsStream(orderId);
    // Need to do this a bit hacky with a ref here since the SuggestionDrawer will not re-render on prop changes
    const isPending = useRef(false);

    const handleClick = async () => {
        if (hasSuggestionRelevantChanges && hasUnsavedChanges) {
            isPending.current = true;
            onSaveDraft().finally(() => {
                isPending.current = false;
            });
        }
        if (hasSuggestionRelevantChanges) {
            refetch();
        }
        push({
            header: { title: translate('closelinkInsights.title') },
            content: (
                <SuggestionDrawer
                    orderId={orderId}
                    onSaveDraft={onSaveDraft}
                    onSendEnquiry={onSendEnquiry}
                    onSuggestionFinished={onSuggestionFinished}
                    isDraftUpdatePending={isPending}
                />
            ),
        });
    };

    return (
        <Button type="button" LeadingIcon={IconSparkle} onClick={handleClick}>
            {translate('closelinkInsights.reviewDraft')}
        </Button>
    );
};
